import { AsideNavigationData, Link, LinkList, LinkTo } from '../../shared/models/app-data-model';

export const getAsideNavLinks = (aside_navigations: AsideNavigationData[]): Link[] => {
    return aside_navigations
        .flatMap((asideNav: AsideNavigationData) => asideNav.link_to)
        .flatMap((linkTo: LinkTo) => linkTo.link_list)
        .map((linkList: LinkList) => {
            return { 'title': linkList.seo?.nav_title || linkList?.title || linkList.link?.title, 'url': linkList?.url || linkList.link?.url }
        }) as Link[];
}